import { render, staticRenderFns } from "./MenuChangeIndex.vue?vue&type=template&id=b7843d6e&scoped=true"
import script from "./MenuChangeIndex.vue?vue&type=script&lang=js"
export * from "./MenuChangeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7843d6e",
  null
  
)

export default component.exports